import {
  EMPTY_DASHBOARD_STATS,
  useSupplierDashboard,
} from "../../../api/supplierDashboardApi"
import { DashboardBoard } from "../../shared/dashboard/DashboardBoard"
import { useSupplierDashboardStore } from "./dashboard/supplierDashboardStore"
import { DASHBOARD_WIDGETS } from "./dashboard/widgetRegistry"

export function DashboardPage() {
  const { data, isLoading, isError, refetch } = useSupplierDashboard()
  return (
    <DashboardBoard
      agentTarget="supplier-studio.dashboard"
      titleKey="MC_SSD_TITLE"
      helpArticle={{
        categoryId: "supplier-studio",
        articleId: "dashboard-lesen",
      }}
      useStore={useSupplierDashboardStore}
      widgets={DASHBOARD_WIDGETS}
      stats={data ?? EMPTY_DASHBOARD_STATS}
      isLoading={isLoading}
      isError={isError}
      refetch={refetch}
    />
  )
}
